import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_paginate = _resolveComponent("paginate")!

  return ($options.show)
    ? (_openBlock(), _createBlock(_component_paginate, {
        key: $data.key,
        modelValue: this.modelValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.modelValue) = $event)),
        "force-page": $options.forcePage,
        "page-count": Math.ceil(this.list.total / this.count),
        "page-range": 5,
        "margin-pages": 1,
        "click-handler": $options.changePage,
        "prev-text": 'Назад',
        "next-text": 'Дальше',
        "container-class": 'pagination-vue',
        "page-class": 'pagination-vue__item'
      }, null, 8 /* PROPS */, ["modelValue", "force-page", "page-count", "click-handler"]))
    : _createCommentVNode("v-if", true)
}